export default __webpack_public_path__ + "static/logo-black-be8bf66f7cc339c16037cbd2fe0ec6ae.png";